import React from 'react';
import { AboutUs1 } from '../components/Data/Arabic';
import { AboutUs2 } from '../components/Data/English';

const AboutUs = ({lang}) => {

    const Data = lang ? AboutUs2 : AboutUs1;

    return (
        <div className="lg:px-20 py-2 lg:py-3 md:px-16 sm:px-10" id='whous'>
            <div className="section mx-auto p-10 lg:p-2 sm:p-0 xl:max-w-[1400px] xl:mx-auto">
                <div className=" m-auto xl:p-16 lg:p-1 sm:p-3 basis-4/5 md:basis-11/12">
                    <div className=" mx-auto text-center relative flex justify-center">
                        <h2 className="xl:text-5xl lg:text-4xl sm:text-3xl py-8 mb-8 text-center font-black">من نحن</h2>
                        <span className="bg-orange w-20 h-1 absolute rounded mt-28"></span>
                    </div>
                    {
                        Data.map(item => (
                        <div key={item.id}>
                            <p className="font-black text-center leading-loose xl:leading-loose xl:text-3xl lg:text-2xl md:text-2xl sm:text-xl lg:px-28 xl:px-44 lg:leading-loose md:leading-loose md:px-12 mb-8 mt-8 sm:px-8">{item.firstP}</p>
                            <p className="font-black text-center leading-loose xl:leading-loose xl:text-3xl lg:text-2xl md:text-2xl sm:text-xl lg:px-12 xl:px-44 lg:leading-loose md:leading-loose mb-8 md:px-10 sm:px-8"> 
                                {item.lastP}
                            </p>
                        </div>   
                        ))
                    }
                    {/* <span className="font-black text-center lg:text-2xl px-40 block text-lightBlue sm:text-xl sm:px-16"><a href="app.js">المزيد ...</a></span> */}
                </div>
            </div>
        </div>
    )
}

export default AboutUs;
